<template>
	<node-view-wrapper class="teaming-tiptap-topic rte-node--draggable">
		<div
			class="rte-node__drag-handle"
			contenteditable="false"
			draggable="true"
			data-drag-handle
		/>
		<div class="teaming-tiptap-topic--left">
			<TeamingCheckbox
				class="teaming-tiptap-topic__checkbox"
				:name="`topic-${ topicId }-reviewed`"
				theme="secondary"
				:isChecked="isReviewed"
				@change="onCheckboxChange"
			/>
		</div>
		<div class="teaming-tiptap-topic--right">
			<node-view-content class="teaming-tiptap-topic__content rte-node__content--draggable" />
			<p contenteditable="false" class="teaming-tiptap-topic__attribution" v-if="attribution">{{ attribution }}</p>
		</div>
	</node-view-wrapper>
</template>

<script>
import { NodeViewWrapper, NodeViewContent, nodeViewProps } from "@tiptap/vue-3";
import { TeamingCheckbox } from "@teaming/common-ui";
import { TeamingTiptapExtensionType } from "@teaming/common-enums";

export default {
	name: "TeamingTiptapTopic",
	components: {
		NodeViewWrapper,
		NodeViewContent,
		TeamingCheckbox,
	},

	props: nodeViewProps,

	computed: {
		topicId() {
			return this.node.attrs.topicId;
		},

		attribution() {
			const creatorName = this.node.attrs[ "creator-name" ];
			if ( !creatorName ) {
				return "";
			}
			return this.$t( "common.TeamingTiptapTopic_attribution", {
				name: creatorName,
			} );
		},

		isReviewed() {
			const isReviewed = this.node.attrs[ "is-reviewed" ];
			return `${ isReviewed }`.trim() === "1";
		},
	},

	methods: {
		onCheckboxChange( e ) {
			this.updateAttributes( {
				"is-reviewed": e.isChecked ? "1" : "0",
			} );
		},
	},

	unmounted() {
		this.extension?.options?.onTeamingExtensionCallback( { nodeType: TeamingTiptapExtensionType.TOPIC, type: "destroy", } );
	},

};
</script>

<style lang="scss">
.teaming-tiptap-topic {
	display: flex;
	flex-direction: row;
	gap: 0.5rem;

	.rte-node__drag-handle {
		transform: translateY(37%);
	}
}

.teaming-tiptap-topic--left {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
}

.teaming-tiptap-topic--right {
	display: flex;
	flex-direction: column;
}

.teaming-tiptap-topic__content {
	@include font-and-line-for(2);
	font-weight: 700;
	color: $tiptap-topic-font-color;
}

.ProseMirror p.teaming-tiptap-topic__attribution {
	@include font-and-line-for(-2);
	color: $tiptap-topic-attribution-font-color;
	padding: 0;
	margin: 0;
}

.teaming-tiptap-topic__checkbox {
	@include font-and-line-for(2);
}
</style>

